// Binds the pure matchup helpers (src/lib/matchup.ts) to the site's existing
// athlete + East vs West data. Shared by the tool UI, the SSG route list in
// vite.config.ts and the pre-rendered pair pages.
import athletesManifest from '../content/events/athletes.generated.json';
import { EVENT_ARCHIVE } from '../content/events/data.generated';
import { RANKINGS_OFFICIAL } from '../content/events/rankings.generated';
import { MATCH_CARD } from './eastVsWest';
import { uniqueProfiles, popularPairs, pairSlug, parsePairSlug, type Profile } from './matchup';

export const MANIFEST = athletesManifest as unknown as Record<string, Profile>;
export const PROFILES: Profile[] = uniqueProfiles(MANIFEST);
export const PROFILE_BY_SLUG = new Map(PROFILES.map((p) => [p.slug, p]));
export const ARCHIVE = EVENT_ARCHIVE;
export const RANKINGS = RANKINGS_OFFICIAL;

/** Pairs pre-rendered as their own pages: the upcoming card, ranking tops, rivalries. */
export const POPULAR_PAIRS: [string, string][] = popularPairs({
  manifest: MANIFEST,
  rankings: RANKINGS_OFFICIAL,
  archive: EVENT_ARCHIVE,
  card: MATCH_CARD,
  limit: 24,
});
export const POPULAR_PAIR_SLUGS = POPULAR_PAIRS.map(([a, b]) => pairSlug(a, b));

export function resolvePair(slug: string): [Profile, Profile] | null {
  const p = parsePairSlug(slug, new Set(PROFILE_BY_SLUG.keys()));
  if (!p) return null;
  return [PROFILE_BY_SLUG.get(p[0])!, PROFILE_BY_SLUG.get(p[1])!];
}
